<!--头部导航-->
<template>
  <div class="container" style="background-color: #fff; min-width: 1200px">
    <div class="logo">
      <img src="@/assets/thdImg/logo/logo.svg" alt />
    </div>
    <div class="module">
      <nav class="nav" ref="mainHeader" style="opacity: 0;">
        <span class="nav-item" :class="{ navActive: topActive == ind }" @click="topTab(ind, item)" v-for="(item, ind) in headItem" :key="ind">
          {{ item.tittle }}</span
        >
        <i class="nav-underline" :style="navLineStyle"></i>
      </nav>
    </div>
    <div class="rightContent">
      <div style="display: flex;align-items: center;margin-right: 20px;">
        小程序授权状态：{{ this.$store.state.loginUserInfo.minAppAuthState ? "已授权" : "未授权" }}
        <div class="authorization pointer" v-if="!this.$store.state.loginUserInfo.minAppAuthState" @click="AppAuth()">授权</div>
      </div>
      <!-- 店铺相关 -->
      <div class="head">
        <img src="../assets/thdImg/home/top_photo.svg" alt style="width: 20px;height: 20px;border-radius: 24px" />
        <!-- <img src="../assets/newHomeIcon/icon_user.png" alt style="vertical-align: middle" /> -->
        <div class="head_showInfo">
          <span class="head-name">
            <span
              class="head-name-tit"
              style="
                display: inline-block;
                vertical-align: middle;
                padding: 0 4px;
              "
              >{{ this.$store.state.loginUserInfo.sellerNick }}</span
            >
          </span>
          <i style="color: #000; position: relative; vertical-align: middle" class="el-icon-arrow-down"></i>
          <!-- 弹出页面 -->
          <div class="hoverElement">
            <div class="top" style="left: 200px">
              <img src="../assets/newHomeIcon/top.png" alt />
            </div>
            <div class="userInfo">
              <div class="headImg">
                <img :src="picImg" alt />
              </div>
              <div class="shop_div">
                <div class="shopName" style="font-weight: 600;">
                  {{ softwarename || this.$store.state.loginUserInfo.sellerNick }}
                </div>
                <div class="vesion">{{ invalidateDate.versionName }}</div>
              </div>
              <div class="shop_div">
                <div class="shopName">
                  小程序授权状态
                </div>
                <div :style="{ color: invalidateDate.minAppAuthState ? '#2670fb' : '#F56C6C' }">
                  {{ invalidateDate.minAppAuthState ? "已授权" : "未授权" }}
                </div>
              </div>
              <div class="shop_div">
                <div class="shopName">
                  进行中的玩法
                </div>
                <div style="color:#2670fb">{{ progressActivity }}</div>
              </div>
              <div class="shop_div">
                <div class="shopName">
                  累计设置玩法
                </div>
                <div style="color:#2670fb">{{ activityCount }}</div>
              </div>
              <div class="callkf1" @click="log_out">退出登录</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { loginController } from "@/api/activityController";
import {
  getSellerInfo,
  getShopInfo,
  switchShop,
  returnOldSystem,
  // getMenuList,
} from "@/api/sellerController";

import { getMenuList } from "@/api/integralCenter/prizeCenter";
import { checkSellerOwnRorNot } from "@/api/public.js"
import { getActivityCount, updateMemberCenterURL } from "@/api/thd";

import { logout } from "@/api/login";
import axios from "axios";

// import { cutHostToSonShop } from "@/api/login";
export default {
  name: "page-header",
  props: {
    paths: {
      type: Array,
      require: true,
    },
  },
  watch: {
    paths:{
      immediate:true,
      handler(newval,oldVal){
      // console.log("this.paths:", this.paths);
      if (this.paths && this.paths.length > 0) {
        let ind = this.paths[0].index;
        this.topActive = ind;
        // console.log(this.topActive);
        if (this.topActive == 5 && this.$route.query.venderId) {
          this.loginEvent();
        }
        // if (this.once === false) {
        //只需要刷新的时候调用一次
        this.bus.$emit("topActive", { index: ind, item: this.headItem[ind] });
        this.$nextTick(() => {
          this.activeNavStyle = this.getNavStyle(this.topActive);
        });

        // this.once = true;
        // }
        // this.$forceUpdate();
      }
      }
    }
  },
  data() {
    return {
      topActive: 0,
      once: false,
      //实时信息数据
      softwarename: "",
      theme: "",
      switchList: [],
      softwareInfo: {
        versionName: "POP版",
      },
      accountSwitches: true,
      activeNavStyle: { left: 0, width: 0 },
      currentNavStyle: null,
      screenWidth: document.body && document.body.clientWidth, // 屏幕尺寸
      venId: null, //商家编号
      progressActivity: 0,
      activityCount: 0,
      pathList: [],
      permissionPath: JSON.parse(localStorage.getItem("permissionPath_thd")) || []
    };
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
      switchListStore: "switchList",
    }),
    venderType() {
      // 是否为自营店铺
      return this.$store.state.loginUserInfo.venderType;
    },
    // 订购类型
    subscribeType() {
      return this.$store.state.loginUserInfo.subscribeType;
    },
    headItem() {
      return this.$store.state.route;
    },
    navLineStyle() {
      let style = this.currentNavStyle || this.activeNavStyle;
      return {
        width: `${style.width}px`,
        left: `${style.left}px`,
      };
    },
    picImg() {
      var defaultImg = require("@/assets/images/home/header.png");

      var img = defaultImg;
      if (this.$store.state.loginUserInfo && this.$store.state.loginUserInfo.picPath) {
        img = this.$store.state.loginUserInfo.picPath;
      }
      return img;
    },
    invalidateDate() {
      var invalidateDate = this.$store.state.loginUserInfo;
      // if (invalidateDate) {
      //   invalidateDate = invalidateDate.substr(0, 10);
      // }
      return invalidateDate;
    },
    daysSoft() {
      var str = "--";
      var invalidateDate = this.invalidateDate;
      if (invalidateDate) {
        str = this.daysBetween(invalidateDate, this.getTodayYMD()) - 1;
      }
      return str;
    },
  },
  async mounted() {
    let { data: res } = await getActivityCount();
    // console.log('data',data)
    this.progressActivity = res.progressActivity;
    this.activityCount = res.activityCount;
    this.bus.$on("topHeader", (obj) => {
      this.topTab(obj.index, obj.item);
    });
    if (
      location.pathname !== "/login" &&
      location.pathname !== "/" &&
      location.pathname !== "/yusms/" &&
      location.pathname !== "/yusms/login" &&
      location.pathname !== "/yusms/redirection"
    ) {
      this.getBindList();
      // 获取菜单
      await this.getPermissions()
      await this.getMenuData();
    }

    // this.topTab();
    const that = this;
    window.onresize = () => {
      return (() => {
        // console.log('window.onresize:')
        window.screenWidth = document.body && document.body.clientWidth;
        that.screenWidth = window.screenWidth + 17; // 17 估计是滚动条的距离
        this.$nextTick(() => {
          this.activeNavStyle = this.getNavStyle(this.topActive);
        });
      })();
    };

    // if (this.topActive == 5 && this.$route.query.venderId) {
    //   this.loginEvent();
    // }
  },

  methods: {
    ...mapMutations({
      editUserInfo: "LOGINUSERINFO",
      editPointUserInfo: "POINTUSERINFO",
      getSwitchList: "getSwitchList",
      saveShopInfo: "SHOPINFO",
    }),
    AppAuth() {
      window.open("https://fuwu.taobao.com/ser/miniAppUse.htm?articleCode=FW_GOODS-1001212154#/", "_blank");
    },
    // 权限
    async getPermissions() {
      let newIds = "10137,10141";
      this.$store.state.newIds = newIds;
      const res = await checkSellerOwnRorNot({ ids: newIds })
      if (res.code == 200) {
        sessionStorage.setItem("permissions", JSON.stringify(res.data))
      }
    },

    //忠诚度管理登录
    async getMenuData() {
      const res = await getMenuList();
      let menulist = JSON.parse(res.data);
      let filterIndex = ""
      if(menulist.length) {
        if(menulist[0].children.length) {
          menulist[0].children.map(async (item, index) => {
            if(item.title == "忠诚度设置") {
              await this.getPermissions()
              if(JSON.parse(sessionStorage.getItem("permissions")).indexOf("10141") == -1) {
                filterIndex = index
              }
            }
          })
          if(filterIndex != "") {
            const arr = menulist[0].children.filter((item, index) => {
              return filterIndex != index
            })
            menulist[0].children = arr
          }
        }
      }
      // let listArr = [
      //   {
      //     children: [],
      //     icon: "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/1000350464_20210914135241296home.png",
      //     menuType: "C",
      //     path: "home",
      //     title: "首页",
      //   },
      //   {
      //     children: [],
      //     icon: "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/yusms/icon/nav_jifenrenwu.png",
      //     menuType: "C",
      //     path: "integralTask",
      //     title: "关注拉粉",
      //     children: [
      //       {
      //         children: [],
      //         menuType: "C",
      //         path: "activeList",
      //         title: "活动列表",
      //       },
      //       {
      //         children: [],
      //         menuType: "C",
      //         path: "signIn?activityType=1",
      //         title: "签到赢豪礼",
      //       },
      //       {
      //         children: [],
      //         menuType: "C",
      //         path: "Grabgifts?activityType=2",
      //         title: "每日抢好礼",
      //       },
      //       {
      //         children: [],
      //         menuType: "C",
      //         path: "followShop?activityType=3",
      //         title: "关注店铺有礼",
      //       },
      //       {
      //         children: [],
      //         menuType: "C",
      //         path: "inviteShop?activityType=5",
      //         title: "邀请关注店铺有礼",
      //       },
      //       {
      //         children: [],
      //         menuType: "C",
      //         path: "inviteCard?activityType=4",
      //         title: "邀请开卡有礼",
      //       },
      //       {
      //         children: [],
      //         menuType: "C",
      //         path: "perfectNews?activityType=6",
      //         title: "完善信息有礼",
      //       },
      //       {
      //         children: [],
      //         menuType: "C",
      //         path: "redPacket?activityType=22",
      //         title: "天降红包雨",
      //       },
      //       {
      //         children: [],
      //         menuType: "C",
      //         path: "fission?activityType=21",
      //         title: "裂变神券",
      //       },
      //     ],
      //   },
      //   {
      //     children: [],
      //     icon: "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/yusms/icon/nav_jifenleyuan.png",
      //     menuType: "C",
      //     path: "integralEden",
      //     title: "无线营销",
      //     children: [
      //       {
      //         children: [],
      //         menuType: "C",
      //         path: "activeList1",
      //         title: "活动列表",
      //       },
      //       // {
      //       //   children: [],
      //       //   menuType: "C",
      //       //   path: "bankCard?activityType=13",
      //       //   title: "开卡礼包",
      //       // },
      //       // {
      //       //   children: [],
      //       //   menuType: "C",
      //       //   path: "giftShop?activityType=14",
      //       //   title: "店铺礼包",
      //       // },
      //       // {
      //       //   children: [],
      //       //   menuType: "C",
      //       //   path: "giftQr?activityType=15",
      //       //   title: "店铺礼包（千人千面）",
      //       // },
      //       {
      //         children: [],
      //         menuType: "C",
      //         path: "firstPurchase?activityType=17",
      //         title: "首购有礼",
      //       },
      //       {
      //         children: [],
      //         menuType: "C",
      //         path: "fgPurchase?activityType=18",
      //         title: "复购有礼",
      //       },
      //       {
      //         children: [],
      //         menuType: "C",
      //         path: "overbooking?activityType=16",
      //         title: "下单有礼",
      //       },
      //       {
      //         children: [],
      //         menuType: "C",
      //         path: "lottergdraw?activityType=19",
      //         title: "下单抽奖",
      //       },
      //       // {
      //       //   children: [],
      //       //   menuType: "C",
      //       //   path: "estimate?activityType=20",
      //       //   title: "评价有礼",
      //       // },
      //     ],
      //   },
      //   {
      //     children: [],
      //     icon: "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/yusms/icon/nav_jifenleyuan.png",
      //     menuType: "C",
      //     path: "interesting",
      //     title: "趣味抽奖",
      //     children: [
      //       {
      //         children: [],
      //         menuType: "C",
      //         path: "activeList2",
      //         title: "活动列表",
      //       },
      //       {
      //         children: [],
      //         menuType: "C",
      //         path: "turntable?activityType=8",
      //         title: "大转盘抽奖",
      //       },
      //     ],
      //   },
      //   {
      //     children: [],
      //     icon: "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/yusms/icon/nav_jifenleyuan.png",
      //     menuType: "C",
      //     path: "gameHub",
      //     title: "游戏中心",
      //     children: [
      //       {
      //         children: [],
      //         menuType: "C",
      //         path: "activeList3",
      //         title: "活动列表",
      //       },
      //       {
      //         children: [],
      //         menuType: "C",
      //         path: "prizeClaw?activityType=23",
      //         title: "疯狂抓娃娃",
      //       },
      //       {
      //         children: [],
      //         menuType: "C",
      //         path: "differences?activityType=24",
      //         title: "大家来找茬",
      //       },
      //     ],
      //   },
      //   // {
      //   //   children: [],
      //   //   icon: "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/yusms/icon/nav_jifenshangcheng.png",
      //   //   menuType: "C",
      //   //   path: "integralMall",
      //   //   title: "互动商城",
      //   // },
      //   {
      //     children: [
      //       {
      //         children: [],
      //         menuType: "C",
      //         path: "mutualMember",
      //         title: "互动会员",
      //       },
      //       {
      //         children: [],
      //         menuType: "C",
      //         path: "memberLevel",
      //         title: "会员等级/积分设置",
      //       },
      //       {
      //         children: [],
      //         menuType: "C",
      //         path: "memberPower",
      //         title: "会员权益",
      //       },
      //     ],
      //     icon: "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/yusms/icon/nav_zhongchengdushezhi.png",
      //     menuType: "C",
      //     path: "integralCenter",
      //     title: "互动中心",
      //   },
      //   {
      //     children: [],
      //     icon: "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/yusms/icon/nav_decoration.png",
      //     menuType: "C",
      //     path: "shopDecoration",
      //     title: "店铺装修",
      //   },
      //   // {
      //   //   children: [
      //   //     {
      //   //       children: [],
      //   //       menuType: "C",
      //   //       path: "coupon_management",
      //   //       title: "优惠券管理",
      //   //     },
      //   //     {
      //   //       children: [],
      //   //       menuType: "C",
      //   //       path: "asset_management",
      //   //       title: "资产项管理",
      //   //     },
      //   //   ],
      //   //   icon: "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/yusms/icon/nav_prize.png",
      //   //   menuType: "C",
      //   //   path: "prizeCenter",
      //   //   title: "奖品中心",
      //   // },
      //   {
      //     children: [
      //       {
      //         children: [],
      //         menuType: "C",
      //         path: "suspension_diagram",
      //         title: "店铺首页悬浮图",
      //       },
      //     ],
      //     icon: "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/yusms/icon/nav_prize.png",
      //     menuType: "C",
      //     path: "promotionMode",
      //     title: "推广方式",
      //   },
      //   {
      //     children: [
      //       {
      //         children: [],
      //         menuType: "C",
      //         path: "flow_analysis",
      //         title: "活动数据",
      //       },
      //       {
      //         children: [],
      //         menuType: "C",
      //         path: "prize_statistics",
      //         title: "奖品统计",
      //       },
      //     ],
      //     icon: "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/yusms/icon/nav_shujufenxi.png",
      //     menuType: "C",
      //     path: "dataAnalysis",
      //     title: "数据分析",
      //   },
      //   {
      //     children: [],
      //     icon: "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/162364_b076e4f2cf4040f6930a8b9182446437.png",
      //     menuType: "C",
      //     path: "brandCustom",
      //     title: "品牌定制",
      //   },
      // ];

      // let arr = [
      //   {
      //     children: [...listArr],
      //     title: "互动营销",
      //     menuType: "C",
      //     path: "/integralCenter",
      //   },
      // ];
      var routerList = menulist.map((item) => {
        return {
          ...item,
          path: "/integralCenter",
        };
      });
      var routerList = routerList;
      var routerStr = JSON.stringify(routerList);
      routerStr = routerStr.replace(/title/g, "tittle");
      routerList = JSON.parse(routerStr);
      // console.log(routerList);
      this.$store.state.route = routerList;
      await this.routeLocal(routerList, "")
      localStorage.setItem("permissionPath_thd", JSON.stringify(this.pathList))
      if(this.permissionPath.join() !== JSON.parse(JSON.stringify(this.pathList)).join()) {
        // 不关闭页面重新刷新的情况
        // 解决同一路由vue缓存机制不刷新的情况
        console.log('菜单权限变化------>', )
        const query = {
          ...this.$route.query,
          timetemp: Date.parse(new Date())
        }
        this.$router.push({ 
          path: this.$route.path,
          query,
        })
      }
    },

    routeLocal(list, parentPath) {
      list.map((item) => {
        const path = item.path.split("?")[0]
        if(path.indexOf("/") != -1) {
          this.pathList.push(parentPath + path)
        } else {
          this.pathList.push(parentPath + "/" + path)
        }
        if(item.children.length) {
          if(path.indexOf("/") != -1) {
            this.routeLocal(item.children, parentPath + path)
          } else {
            this.routeLocal(item.children, parentPath + "/" + path)
          }
        }
      })
    },

    toShop() {
      window.open(`https://mall.jd.com/index-${this.$store.state.loginUserInfo.venderId}.html`, "_blank");
    },
    handlePlatform() {
      var url = "http://yei8.cn/AXsH";
      window.open(url, "_blank");
    },

    toOldVersion() {
      // 返回旧版
      returnOldSystem().then((res) => {
        if (res.code == "1") {
          var url = res.data.url + "?" + "token=" + res.data.token;
          window.location = url;
        }
      });
    },
    getBindList() {
      getSellerInfo().then((res) => {
        this.$store.state.loginUserInfo = {
          ...res.data,
          expiredIn: res.data.softwareExpire,
          invalidateDate: res.data.softwareExpire,
          sellerNick: res.data.shopTitle,
          sellerNick2: res.data.sellerNick,//和上面的区分一下 不敢动 不知道有没有地方调用
          sellerPin: res.data.shopTitle,
          venderId:res.data.sellerId,
        };
      });
    },
    topTab(ind, item) {
      // console.log(ind,item, "1111111");
      this.topActive = ind;
      this.activeNavStyle = this.getNavStyle(ind);
      var path = item.path;

      if (item.children && item.children[0].path) {
        path = item.path + "/" + item.children[0].path;
      }

      if (item.children && item.children[0].path && item.children[0].children && item.children[0].children[0].path) {
        path = item.path + "/" + item.children[0].path + "/" + item.children[0].children[0].path;
      }

      // console.log("path==", path);
      this.$router.push({ path: path });
      this.bus.$emit("topActive", { index: ind, item: item });
      if (item.path == "/integralCenter") {
        this.loginEvent();
      }
    },
    //登录
    loginEvent() {
      let venderId = { venderId: this.venId };
      // let venderId = { venderId: "10231814" };
      // loginController(venderId)
      //   .then((res) => {
      //     sessionStorage.setItem("loginValue", res.code);
      //     // console.log(res);
      //     if (res && res.code == 1) {
      //       if (
      //         res.data.appInfo.status == 1 &&
      //         res.data.orderInfo.status == 1
      //       ) {
      //         console.log("登录成功");
      //         this.editPointUserInfo(res.data.orderInfo)
      //       } else if (res.data.orderInfo.status != 1) {
      //         let routeUrl = this.$router.resolve({
      //           path: "/prizeCenter2",
      //         });
      //         window.open(routeUrl.href, "_blank");
      //         window.open("/home", "_self");
      //       } else {
      //         window.open(res.data.appInfo.authUrl, "_blank");
      //         window.open("/home", "_self");
      //       }
      //     } else {
      //       if (res.data.data.orderInfo.status != 1) {
      //         let routeUrl = this.$router.resolve({
      //           path: "/prizeCenter2",
      //         });
      //         window.open(routeUrl.href, "_blank");
      //       } else {
      //         window.open(res.data.data.appInfo.authUrl, "_blank");
      //       }
      //       window.open("/home", "_self");
      //     }
      //   })
      //   .catch((res) => {
      //     this.$message.error("积分登录失败");
      //     window.open("/home", "_self");
      //   });
    },

    toBindShop() {
      let routeUrl = this.$router.resolve({
        path: "/backstage/account/store_binding",
        // query: { to: "/account/store_binding" },
      });
      window.open(routeUrl.href, "_blank");
    },
    // 跳转到充值页面
    toRecharge() {
      // this.$router.push({ path: "/backstage" ,query: {to:'/backstage/smsmanage/charge'}});
      let routeUrl = this.$router.resolve({
        path: "/backstage",
        query: { to: "/backstage/sms_management" },
      });
      window.open(routeUrl.href, "_blank");
      // this.$router.push({ path: "sms_management"});
      // this.$router.push("/integralCenter/shopDecoration");
    },
    //去设置页面
    toSetting() {
      let routeUrl = this.$router.resolve({
        path: "/backstage",
        query: { to: "/backstage/account/account" },
      });
      window.open(routeUrl.href, "_blank");
    },
    switchStore() {
      this.accountSwitches = !this.accountSwitches;
    },
    //退出登录
    log_out() {
      logout().then((res) => {
        location.href =
          "https://oauth.taobao.com/authorize?response_type=code&client_id=12666072&redirect_uri=http://tb.yusms.com/api/login/tblogin&state=1212&view=web";
      });

      // location.href =
      //   "https://passport.jd.com/oauth/login?platform_id=1&app_id=D6051BB72B5192728A55652FDC6A4564&app_name=5LqR55%2Bt5L%2BhX0NSTV%2Fnn63kv6HlhbPmgIBfX%2BefreS%2FoeiQpemUgA%3D%3D&ReturnUrl=https%3A%2F%2Fopen-oauth.jd.com%2Foauth2%2Fauthorize%3FsessionToken%3DEd93i6DYH3XG0SCF1I85iH2Tw5UMJVbz&icon_url=%2F%2Fimg30.360buyimg.com%2Fdevcenter%2Fjfs%2Ft10174%2F205%2F1860345672%2F14732%2F541c48a4%2F59e87ecdNf8c5f4fe.png&signature=94102aec7a452f40609f4ce1cbebbadf75246d1e&nls=0&applabel=L_APP_MARKET,L_APP_H5,L_APP_OAUTH_AGREEMENT_LEVEL_THREE";
    },
    toggleSwitch(item) {
      if (!this.accountSwitches) {
        switchShop({ sellerNick: item.shopName }).then((res) => {
          if (res.code == "1") {
            // this.softwarename = item;
            this.getBindList();
            // 刷新下
            this.$router.push({
              path: "/refresh",
            });
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    feedback() {
      this.$emit("openWindow", true);
    },
    getNavStyle(index) {
      // console.log('this.screenWidth', this.screenWidth)
      let childNodes = this.$refs.mainHeader.childNodes;
      let width = Number(childNodes[index] && childNodes[index].clientWidth);
      let left = 0;
      if (index > 0) {
        for (let i = 0; i < index; i++) {
          if (this.screenWidth < 1370) {
            left += childNodes[i].clientWidth + 5;
          } else if (this.screenWidth > 1369 && this.screenWidth < 1572) {
            left += childNodes[i].clientWidth + 25;
          } else {
            left += childNodes[i].clientWidth + 50;
          }
        }
      }
      return { width, left };
    },

    // 求两个时间的天数差 日期格式为 YYYY-MM-dd
    daysBetween(DateOne, DateTwo) {
      var OneMonth = DateOne.substring(5, DateOne.lastIndexOf("-"));
      var OneDay = DateOne.substring(DateOne.length, DateOne.lastIndexOf("-") + 1);
      var OneYear = DateOne.substring(0, DateOne.indexOf("-"));

      var TwoMonth = DateTwo.substring(5, DateTwo.lastIndexOf("-"));
      var TwoDay = DateTwo.substring(DateTwo.length, DateTwo.lastIndexOf("-") + 1);
      var TwoYear = DateTwo.substring(0, DateTwo.indexOf("-"));

      var cha = (Date.parse(OneMonth + "/" + OneDay + "/" + OneYear) - Date.parse(TwoMonth + "/" + TwoDay + "/" + TwoYear)) / 86400000;
      return Math.abs(cha);
    },

    // 获取当前时间. 格式为：年-月-日
    getTodayYMD() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var month = month < 10 ? "0" + month : month;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var ymdStr = year + "-" + month + "-" + day;
      return ymdStr;
    },

    toUserInform() {
      this.$emit("Fun_isShow_page");
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .theme-picker {
  left: 5px;
  opacity: 0;
}
.rightContent {
  display: flex;
  align-items: center;
  float: right;
  font-size: 14px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: #333333;
  height: 60px;
  line-height: 60px;
  text-align: center;
  .authorization {
    width: 60px;
    height: 28px;
    background: rgba(38, 112, 251, 0.1);
    border-radius: 8px;
    border: 1px solid #2670fb;
    color: #2670fb;
    font-size: 14px;
    line-height: 28px;
    text-align: center;
    // margin: 0 10px;
    margin-left: 10px;
  }
  .head-name {
    .head-name-tit {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 106px;
    }
    // @media screen and (max-width: 1320px) {
    // @media screen and (max-width: 1780px) {
    //   display: none;
    // }
  }

  .message {
    min-width: 1362px;
    display: inline-block;
    position: relative;
    margin-right: 32px;
    @media screen and (max-width: 1720px) {
      display: none;
    }
    i {
      font-size: 35px;
      vertical-align: bottom;
      margin-right: 6px;
    }
    .hoverEl {
      width: 229px;
      height: 117px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 4px 10px 0px rgba(32, 98, 231, 0.09);
      position: absolute;
      top: 65px;
      left: -74px;
      display: none;
      border-radius: 5px;
      padding-left: 14px;
      padding-right: 14px;
      padding-top: 30px;
      line-height: normal;
      text-align: left;
      .text {
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        margin-bottom: 4px;
      }
      .num {
        font-size: 28px;
        font-family: DINAlternate-Bold;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        .button {
          width: 72px;
          height: 26px;
          /*background: rgba(32, 98, 231, 1);*/
          /*box-shadow: 0px 3px 6px 0px rgba(32, 98, 231, 0.6);*/
          border-radius: 6px;
          font-size: 14px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 26px;
          text-align: center;
          display: inline-block;
          vertical-align: middle;
          cursor: pointer;
        }
      }
    }
  }
  .message:hover {
    .hoverEl {
      display: inline-block;
    }
  }
  .expireTime {
    display: inline-block;
    margin-right: 32px;
    position: relative;
    @media screen and (max-width: 1600px) {
      display: none;
    }
    @media screen and (max-width: 1720px) {
      display: none;
    }
    i {
      font-size: 35px;
      vertical-align: bottom;
      margin-right: 6px;
    }
    .hoverEle {
      width: 229px;
      height: 130px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 4px 10px 0px rgba(32, 98, 231, 0.09);
      position: absolute;
      top: 65px;
      left: -74px;
      display: none;
      border-radius: 5px;
      padding-left: 14px;
      padding-right: 14px;
      padding-top: 30px;
      line-height: normal;
      text-align: left;
      .text {
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        margin-bottom: 4px;
      }
      .num {
        font-size: 28px;
        font-family: DINAlternate-Bold;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        .button {
          width: 70px;
          height: 28px;
          background: rgba(32, 98, 231, 1);
          box-shadow: 0px 3px 6px 0px rgba(32, 98, 231, 0.6);
          border-radius: 6px;
          font-size: 14px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 28px;
          text-align: center;
          display: inline-block;
          vertical-align: middle;
          cursor: pointer;
        }
      }
      .time {
        color: rgba(153, 153, 153, 1);
        margin-top: 10px;
      }
    }
  }
  .expireTime:hover {
    .hoverEle {
      display: inline-block;
    }
  }
  .head {
    display: inline-block;
    width: auto;
    height: 48px;
    line-height: 40px;
    vertical-align: top;
    margin-right: 15px;
    position: relative;
    margin-top: 8px;
    // @media only screen and (max-width:1440px){
    @media only screen and (max-width: 1660px) {
      margin-right: 10px;
    }
    img {
      display: inline-block;
      vertical-align: middle;
      // background-color: #fff !important;
    }
    .hoverElement {
      width: 255px;
      height: 275px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 4px 10px 0px rgba(32, 98, 231, 0.09);
      position: absolute;
      top: 45px;
      right: -24px;
      display: none;
      border-radius: 5px;
      padding-left: 24px;
      padding-right: 24px;
      padding-top: 18px;
      line-height: normal;
      text-align: left;
      .xiantiao {
        width: 100%;
        height: 1px;
        background: #f0f0f0;
        opacity: 1;
        margin: 12px 0;
      }
      .userInfo {
        .headImg {
          margin-top: 10px;
          width: 207px;
          height: 68px;
          border-radius: 24px;
          display: inline-block;
          img {
            width: 207px;
            height: 68px;
            border-radius: 4px;
          }
        }
        .shopName {
          width: 130px;
          font-size: 14px;
          // top: 10px;
          // left: -14px;
          position: relative;
          font-family: PingFangSC-Regular;
          color: rgba(51, 51, 51, 1);
          display: inline-block;
          vertical-align: top;
          margin-left: 0px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          // &:hover {
          //   color: #2670fb;
          // }
        }
        .vesion {
          position: relative;
          // left: 157px;
          // top: -8px;
          width: 54px;
          height: 18px;
          background: #fff1e9;
          opacity: 1;
          border-radius: 12px;
          // width: 54px;
          padding: 2px;
          height: 20px;
          font-size: 12px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: #653517;
          display: inline-block;
          line-height: 15px;
          text-align: center;
          vertical-align: bottom;
        }
      }
      .callkf {
        cursor: pointer;
        height: 22px;
        line-height: 22px;
        text-align: center;
        position: absolute;
        margin: 0px 0px 0 55px;
        width: 98px;
        // height: 32px;
        font-size: 16px;
        // font-family: PingFang SC;
        font-weight: 400;
        border-radius: 3px;
        // padding: 5px 12px;
        // line-height: 21px;
        color: #999999;
      }
      .callkf:hover {
        color: #2670fb;
      }
      .setting {
        cursor: pointer;
        height: 40px;
        line-height: 22px;
        text-align: center;
        position: absolute;
        border-top: 1px solid #f0f0f0;
        top: 215px;
        left: 0px;
        width: 50%;
        // height: 32px;
        font-size: 16px;
        // font-family: PingFang SC;
        font-weight: 400;
        padding-top: 18px;
        // border-radius: 3px;
        // padding: 5px 12px;
        // line-height: 21px;
        color: #999999;
        &:hover {
          color: #7f85e9;
        }
      }
      .callkf1 {
        cursor: pointer;
        height: 41px;
        line-height: 41px;
        text-align: center;
        border-top: 1px solid #f0f0f0;
        padding-top: 4px;
        width: 100%;
        font-size: 16px;
        color: #999999;
      }
      .callkf1:hover {
        color: #2670fb;
      }
      .switch {
        height: 150px;
        // background: linear-gradient(90deg, #ff4e4c 0%, #ff783f 100%);
        color: #333333;
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        // height: 150px;
        overflow: auto;
        .switch-body {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 8px;
          width: 100%;
        }
        .switch-body1 {
          border-bottom: 1px solid #f0f0f0;
          padding-top: 4px;
          padding-bottom: 14px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 8px;
          width: 100%;
        }
        .switch-content {
          display: flex;
          align-items: center;
        }
        img {
          width: 32px;
          color: #709fff;
        }
        .noimagesBox {
          width: 207px;
          // height: 100px;

          background: #fff;
          // opacity: 1;
          // border-radius: 4px;
        }
        .toBindShop {
          padding: 5px 18px;
          position: absolute;
          top: 253px;
          left: 72px;
          width: 110px;
          color: #2670fb;
          height: 32px;
          background: #fff4f4;
          border: 1px solid #2670fb;
          opacity: 1;
          border-radius: 4px;
          &:hover {
            color: #2670fb;
            background-color: #ffe5e5;
          }
          &:active {
            color: #2670fb;
            border: 1px solid #2670fb;
            background-color: #fff4f4;
          }
        }
        .toggle {
          padding: 3px 20px;
          width: 70px;
          height: 28px;
          cursor: pointer;
          color: #2670fb;
          border: 1px solid #2670fb;
          border-radius: 4px;
          background-color: #fff4f4;
          &:hover {
            color: #2670fb;
            background-color: #ffe5e5;
          }
          &:active {
            color: #2670fb;
            border: 1px solid #2670fb;
            background-color: #fff4f4;
          }
        }
        .toggle1 {
          padding: 3px 20px;
          width: 70px;
          height: 28px;
          cursor: pointer;
          color: #7f85e9;
          border: 1px solid #7f85e9;
          border-radius: 4px;
          background-color: #f7f8fe;
          &:hover {
            color: #7f85e9;
            background-color: #f2f3fd;
          }
          &:active {
            color: #7f85e9;
            border: 1px solid #7f85e9;
            background-color: #ecedfc;
          }
        }
      }
      .qiehuan {
        cursor: pointer;
        float: right;
        opacity: 1;
        position: relative;
        top: 0px;
        i {
          font-size: 14px;
        }
        .switch {
          color: #7f85e9;
          font-size: 13px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
        }
        .accomplish {
          color: #7f85e9;
          font-size: 13px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
        }
      }
      .qiehuan:hover {
        opacity: 0.7;
      }

      .text {
        font-size: 12px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        margin-bottom: 4px;
      }
      .num {
        font-size: 20px;
        font-family: DINAlternate-Bold;
        font-weight: bold;
        color: #252c38;
        .button {
          width: 70px;
          height: 28px;
          // float: right;
          font-size: 14px;
          line-height: 24px;
          text-align: center;
          display: inline-block;
          vertical-align: middle;
          cursor: pointer;
          font-weight: 400;
          color: #2670fb;
          border: 1px solid #2670fb;
          border-radius: 4px;
          background-color: #fff4f4;
          &:hover {
            color: #2670fb;
            background-color: #ffe5e5;
          }
          &:active {
            color: #2670fb;
            border: 1px solid #2670fb;
            background-color: #fff4f4;
          }
        }
      }
      .text1 {
        font-size: 12px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: #252c38;
        margin-bottom: 4px;
        margin-top: 4px;
      }
      .num1 {
        font-size: 20px;
        font-family: DINAlternate-Bold;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        .button {
          width: 70px;
          height: 28px;
          font-size: 14px;
          line-height: 24px;
          text-align: center;
          display: inline-block;
          vertical-align: middle;
          font-weight: 400;
          cursor: pointer;
          color: #2670fb;
          border: 1px solid #2670fb;
          border-radius: 4px;
          background: rgba(38, 112, 251, 0.1);
          &:hover {
            color: #2670fb;
            background: rgba(38, 112, 251, 0.3);
          }
          &:active {
            color: #2670fb;
            border: 1px solid #2670fb;
            background: rgba(38, 112, 251, 0.3);
          }
        }
      }
      .time {
        color: #7f85e9;
        margin-top: 10px;
        font-size: 12px;
      }
    }
  }
  .head_showInfo {
    display: inline-block;
    cursor: pointer;
  }
  .head_showInfo:hover {
    .hoverElement {
      display: inline-block;
    }
  }
  .help {
    display: flex;
    align-items: center;
    height: 60px;
    width: 60px;
    line-height: 60px;
    margin-right: 30px;
    .edition {
      display: inline-block;
      width: 62px;
      height: 18px;
      color: #fff;
      text-align: center;
      background: url("../assets/images/edition_bg.png") no-repeat 100% center;
      span {
        display: inline-block;
        transform: scale(0.8);
      }
    }
    // @media only screen and (max-width:1440px){
    @media only screen and (max-width: 1660px) {
      margin-right: 10px;
    }
    vertical-align: top;
  }
  .changeSkin {
    display: inline-block;
    vertical-align: bottom;
    margin-right: 20px;
    height: 60px;
    width: 32px;
  }
  .jiuban_button {
    width: 96px;
    height: 28px;
    font-size: 13px;
    font-weight: 400;
    border-radius: 4px;
    background: linear-gradient(131deg, #ff6d6e 0%, #fe333b 100%);
    color: #ffffff;
    border: none;
  }
}

.top {
  display: flex;
  justify-content: center;
  position: absolute;
  top: -14px;
  left: 110px;
  img {
    width: 20px;
    height: 20px;
  }
}

.customerService {
  padding: 20px;
  .title {
    height: 28px;
    font-size: 20px;
    font-family: PingFangSC-Medium;
    font-weight: 900;
    color: rgba(51, 51, 51, 1);
    line-height: 28px;
  }
  .toService {
    margin-top: 13px;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    line-height: 20px;
    .phone {
      display: inline-block;
      font-size: 14px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(32, 98, 231, 1);
      line-height: 20px;
      img {
        width: 28px;
        height: 28px;
        vertical-align: middle;
        margin-right: 6px;
      }
    }
  }

  .wechatService {
    margin-top: 12px;
    display: flex;
    padding: 0 10px;
    justify-content: space-between;
    .QRcode {
      width: 95px;
      height: 95px;
      background: rgba(216, 216, 216, 1);
      border: 1px solid rgba(151, 151, 151, 1);
    }
  }
}
.help {
  // margin-top: 10px;
  display: flex;
  // padding: 0 10px;
  justify-content: space-between;
  div {
    width: 96px;
    height: 28px;
    border-radius: 6px;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(32, 98, 231, 1);
    line-height: 28px;
    text-align: center;
    cursor: pointer;
    i {
      vertical-align: middle;
    }
  }
  .helpTitle {
    border: none;
    width: 85px;
    color: #fff;
    line-height: 20px;
    height: 20px;
    margin-top: 5px;
    img {
      width: 11px;
      height: 11px;
      margin-left: 3px;
    }
  }
}

.container {
  height: 60px;
  width: 100%;
  transition: all 0.5s;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 30;
  border-bottom: 1px solid #d5d6de;
  box-shadow: 0px 2px 20px 1px rgba(0, 0, 0, 0.05);
  .logo {
    box-sizing: border-box;
    width: 200px;
    background: #2670fb;
    opacity: 1;
    vertical-align: top;
    display: inline-block;
    height: 60px;
    line-height: 65px;
    border-radius: 0px 24px 0px 0px;
    @media screen and (min-width: 1500px) and (max-width: 1700px) {
      line-height: 68px;
    }
    @media screen and (min-width: 1400px) and (max-width: 1499px) {
      line-height: 69px;
    }
    @media screen and (max-width: 1399px) {
      line-height: 70px;
    }
    padding: 5px 0;
    text-align: center;
    img {
      display: inline-block;
      margin-top: -22px;
      // width: 140px;
      @media screen and (max-width: 1366px) {
        margin-top: -24px;
      }
      // height: 40px;
      vertical-align: middle;
    }
    img:after {
      content: "";
      display: inline-block;
      vertical-align: middle;
    }
  }
  .module {
    display: inline-block;
    margin-left: 20px;
    @media screen and (min-width: 1440px) {
      margin-left: 0;
    }
    .nav {
      margin-left: 20px;
      display: inline-flex;
      position: relative;
      height: 60px;
      line-height: 72px;
      overflow: hidden;
      .nav-item {
        position: relative;
        padding: 0 10px;
        margin-right: 50px;
        bottom: 5px;
        color: #d5d6de;
        font-size: 16px;
        cursor: pointer;
        &:hover::before {
          bottom: -5px;
          opacity: 1;
          // @media screen and (max-width: 1300px) {
          //   bottom: -2px;
          // }
        }
        &::before {
          content: "";
          position: absolute;
          bottom: -11px;
          left: 0;
          width: 100%;
          height: 4px;
          background-color: #555a7a;
          border-radius: 8px 8px 0 0;
          // opacity: 0;
          // transition: 0.3s;
        }
      }
      .nav-underline {
        position: absolute;
        bottom: 0;
        margin-left: 2px;
        display: block;
        height: 4px;
        top: 56px;
        border-radius: 8px 8px 0 0;
        background-color: #2670fb;
        transition: all 0.4s ease-in-out;
      }
      .navActive {
        color: #fff;
      }
      // .nav-item.navActive {
      //   // &::before {
      //   //   bottom: 0;
      //   //   opacity: 1;
      //   //   background-color: #2670FB;
      //   // }
      // }
    }
    .item {
      position: relative;
      display: inline-block;
      font-size: 16px;
      font-weight: 400;
      color: #d5d6de;
      line-height: 30px;
      text-align: center;
      margin-left: 64px;
      cursor: pointer;
      height: 30px;
      &:hover {
        color: white;
        &::before {
          content: "";
          width: 150%;
          background-color: #555a7a;
          height: 4px;
          font-size: 16px;
          position: absolute;
          bottom: -11px;
          border-radius: 4px;
          left: -50%;
          transform: translateX(18%);
        }
      }
    }
    .active {
      width: 150%;
      background-color: #2670fb;
      height: 4px;
      font-size: 16px;
      position: absolute;
      bottom: -11px;
      border-radius: 4px;
      left: -50%;
      transform: translateX(18%);
    }
    .item.tabActive {
      color: #fff !important;
    }
  }
}

.headerContactBox {
  padding: 20px 10px !important;
  .info {
    padding: 0 9px 17px 9px;
    border-bottom: 1px solid #f3f3f3;
    color: #333;
    font-size: 14px;
    .labelTxt {
      display: inline-block;
      width: 65px;
    }
    .btnContact {
      position: relative;
      margin-left: 6px;
      padding: 0 15px;
      line-height: 20px;
      height: 20px;
      border-radius: 2px;
      border: 1px solid #ccc;
      background: #fff;
      font-size: 14px;
      color: #999;
      cursor: pointer;
      transition: all 0.2s linear;
      outline: none;
      .hoverIcon {
        position: absolute;
        left: 15px;
        top: 3px;
        opacity: 0;
      }
      &:hover {
        color: #5882fb;
        border: 1px solid #5882fb;
        background: rgba(88, 130, 251, 0.1);
        .icon {
          opacity: 0;
        }
        .hoverIcon {
          width: 13px;
          height: 13px;
          opacity: 1;
        }
      }
    }
  }
  .foot {
    display: flex;
    justify-content: space-between;
    margin-top: 14px;
    .btn {
      width: 110px;
      height: 28px;
      line-height: 26px;
      border: 1px solid #ccc;
      color: #999;
      border-radius: 2px;
      cursor: pointer;
      transition: all 0.2s linear;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        color: #5882fb;
        background: rgba(88, 130, 251, 0.1);
        border: 1px solid rgba(88, 130, 251, 1);
      }
      &:active {
        color: #3d6fff;
        background: rgba(88, 130, 251, 0.1);
        border: 1px solid rgba(61, 111, 255, 1);
      }
    }
  }
}
@media screen and (min-width: 1369px) and (max-width: 1572px) {
  .container {
    .module {
      .nav {
        .nav-item {
          margin-right: 25px;
        }
      }
    }
  }
}
@media screen and (max-width: 1369px) {
  .container {
    .module {
      .nav {
        .nav-item {
          margin-right: 5px;
        }
      }
    }
  }
}

.shop_div {
  width: 100%;
  display: flex;
  height: 32px;
  align-items: center;
  // justify-content: space-between;
}
</style>
